import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { fmtGHS } from "@/lib/format";

export const packLabel = (p) => {
  const n = Number(p?.units_per_pack) || 0;
  return n ? `1 pack = ${n} unit${n > 1 ? "s" : ""}${p.pack_size ? ` (${p.pack_size})` : ""}` : "";
};

// Optional pack entry: packs × price per pack → selling units + cost per unit. Hidden when product has no units per pack.
export function PackEntry({ product, onApply, testId, quantity, unitCost }) {
  const upp = Number(product?.units_per_pack) || 0;
  const [packs, setPacks] = useState("");
  const [price, setPrice] = useState("");
  useEffect(() => { setPacks(""); setPrice(""); }, [product?.id]);
  if (!upp) return null;
  const update = (np, pr) => {
    setPacks(np); setPrice(pr);
    const n = Number(np), c = Number(pr), out = {};
    if (n > 0) out.quantity = n * upp;
    if (c > 0) out.unitCost = Math.round((c / upp) * 10000) / 10000;
    onApply(out);
  };
  const n = Number(packs), c = Number(price);
  const stale = (n > 0 && Number(quantity) !== n * upp) || (c > 0 && Math.abs(Number(unitCost) - c / upp) > 0.0001);
  return (
    <div className="rounded-md border border-sky-200 bg-sky-50 dark:bg-sky-500/10 dark:border-sky-500/30 px-2.5 py-1.5 flex flex-wrap items-end gap-2 text-xs" data-testid={testId}>
      <span className="self-center font-medium text-sky-900 dark:text-sky-200" data-testid={`${testId}-label`}>{packLabel(product)}</span>
      <div className="w-20"><Label className="text-[10px]">Packs</Label>
        <Input className="h-8" type="number" min={0} value={packs} onChange={(e) => update(e.target.value, price)} data-testid={`${testId}-packs`} /></div>
      <div className="w-24"><Label className="text-[10px]">Price per pack</Label>
        <Input className="h-8" type="number" min={0} step="0.01" value={price} onChange={(e) => update(packs, e.target.value)} data-testid={`${testId}-price`} /></div>
      {(n > 0 || c > 0) && !stale && (
        <span className="self-center text-sky-900 dark:text-sky-200" data-testid={`${testId}-result`}>
          = {n > 0 ? `${n * upp} units` : "— units"}{c > 0 ? ` at ${fmtGHS(c / upp)} each` : ""}
        </span>
      )}
    </div>
  );
}
